/* ============
 * All Product Types
 * ============
 *
 * All product types.
 */

import Vue from 'vue';
import store from './../../store';
import producerTransformer from './../../transformers/producer';

const success = ({ data }, resolve) => {
  const producers = producerTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllProducers', producers);
  resolve();
};

const failed = (error, reject) => reject(error);

// Display product types.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('producers')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/producer/all.js